import { useTrackingContext, type UseTrackingContextReturn } from './tracking/context';
import { useTrackingDeposit, type UseTrackingDepositReturn } from './tracking/deposit';
import { useTrackingGeneral, type UseTrackingGeneralReturn } from './tracking/general';
import { wrapTrackFunctions } from './tracking/internal/core';
import { useTrackingNegotiation, type UseTrackingNegotiationReturn } from './tracking/negotiation';
import { useTrackingOffer, type UseTrackingOfferReturn } from './tracking/offer';
import { useTrackingSdp, type UseTrackingSdpReturn } from './tracking/sdp';
import { useTrackingSignup, type UseTrackingSignupReturn } from './tracking/signup';
import { useTrackingSlp, type UseTrackingSlpReturn } from './tracking/slp';

export type UseTrackingReturn = UseTrackingContextReturn &
    UseTrackingDepositReturn &
    UseTrackingGeneralReturn &
    UseTrackingNegotiationReturn &
    UseTrackingOfferReturn &
    UseTrackingSdpReturn &
    UseTrackingSlpReturn &
    UseTrackingSignupReturn;

export const useTracking = (): UseTrackingReturn => {
    const contextTracking = useTrackingContext();
    const depositTracking = useTrackingDeposit();
    const generalTracking = useTrackingGeneral();
    const negotiationTracking = useTrackingNegotiation();
    const offerTracking = useTrackingOffer();
    const sdpTracking = useTrackingSdp();
    const slpTracking = useTrackingSlp();
    const signupTracking = useTrackingSignup();

    return wrapTrackFunctions({
        ...contextTracking,
        ...depositTracking,
        ...generalTracking,
        ...negotiationTracking,
        ...offerTracking,
        ...sdpTracking,
        ...slpTracking,
        ...signupTracking,
    });
};
